import { loadFromPagination } from './propiedades'
import { pick, paramsForProperties } from './api'
import { browserHistory } from 'react-router'

export const actionTypes = {
	PAGE_PREV: 'meta/PAGE_PREV',
	PAGE_NEXT: 'meta/PAGE_NEXT',
  SET_CANT_ELEMENTS: 'propiedades/SET_CANT_ELEMENTS',
  SET_LIST_DATA: 'meta/SET_LIST_DATA',
  SET_ORDER: 'meta/SET_ORDER',
  CHANGE_PAGE: 'meta/CHANGE_PAGE',
  RESET_INITIAL_PAGE: 'meta/RESET_INITIAL_PAGE',
	URL_UPDATED: 'meta/URL_UPDATED'
}

export const pagePrevSync = () => {
	return {
		type: actionTypes.PAGE_PREV,
	}
}

export const pageNextSync = () => {
	return {
		type: actionTypes.PAGE_NEXT,
	}
}

export const setCantElements = (value) => {
  return (dispatch) => {
    dispatch(changeElements(value))
    dispatch(loadFromPagination())
  }
}

export const changeElements = (value) => {
  return {
    type: actionTypes.SET_CANT_ELEMENTS,
    value: value
  }
}

export const setListData = (data) => {
  return {
    type: actionTypes.SET_LIST_DATA,
    data: data
  }
}

export const setOrder = (value) => {
  return (dispatch) => {
    dispatch(changeOrder(value))
    dispatch(loadFromPagination())
  }
}

export const changeOrder = (value) => {
  return {
    type: actionTypes.SET_ORDER,
    value: value
  }
}

export const changeListPages = (value) => {
  var page = value + 1
  return (dispatch) => {
    dispatch(changePage(page))
    dispatch(loadFromPagination())
  }
}

export const reloadPage = (value) => {
  return (dispatch) => {
    dispatch(changePage(value))
    dispatch(loadFromPagination())
  }
}


export const updateUrl = (q) => {
	return (dispatch, getStore) => {
		let nq = JSON.stringify(pick(paramsForProperties(getStore())))
		if (q &&
			JSON.stringify(nq) !== JSON.stringify(q)) {
			browserHistory.replace('/propiedades?q='+JSON.stringify(pick(paramsForProperties(getStore()))))
		}
		dispatch(urlUpdated())
	}

}

function urlUpdated() {
	return {
		type: actionTypes.URL_UPDATED
	}
}

function changePage (page) {
  return {
    type: actionTypes.CHANGE_PAGE,
    value: page
  }
}

export const resetPage = () => {
  return {
    type: actionTypes.RESET_INITIAL_PAGE
  }
}



// WEBPACK FOOTER //
// ./src/actions/meta.js